// Parent product component
if (!customElements.get('component-breadcrumbs')) {
  customElements.define('component-breadcrumbs', class Breadcrumbs extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('.js-breadcrumb').forEach(breadcrumb => {
        breadcrumb.addEventListener('click', () => {
          this.sendBreadcrumbClickGTMData(breadcrumb);
        });
      });
    }
    sendBreadcrumbClickGTMData(breadcrumb) {
      window.sendGTMData && window.sendGTMData({
        event: 'plp_breadcrumbs',
        breadcrumb: breadcrumb.href
      });
    }
  });
}
